import { useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { toast } from "sonner";

export const WA_TAB = "crm-whatsapp-web";

export const openWhatsAppWeb = (t) => {
  const phone = (t.phone || t.wa_id || "").replace(/\D/g, "");
  const url = `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(t.greeting || "")}`;
  const w = window.open(url, WA_TAB);
  if (w) w.focus();
};

export const useHandle = (onDone) => {
  const [busy, setBusy] = useState(false);
  const handle = async (t) => {
    setBusy(true);
    try {
      await api.post(`/wa/threads/${t.wa_id}/handle`, {});
      toast.success("Marcado como atendido");
      onDone?.();
    } catch { toast.error("Não foi possível marcar como atendido"); }
    setBusy(false);
  };
  return { busy, handle };
};

export const clientLine = (c) => c
  ? `${c.panel_user || "-"} · ${c.account || "-"} · vence ${fmtDate(c.due_date)}${c.is_trial ? " · teste" : ""}`
  : "Número não encontrado nos clientes";

export const timeAgo = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "agora";
  if (s < 3600) return `há ${Math.floor(s / 60)} min`;
  if (s < 86400) return `há ${Math.floor(s / 3600)} h`;
  return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const LATE_MIN = 30;
export const waitMin = (t) => Math.floor((Date.now() - new Date(t.open_since || t.last_at).getTime()) / 60000);
export const isLate = (t) => waitMin(t) >= LATE_MIN;
export const waitLabel = (t) => {
  const m = waitMin(t);
  return m < 60 ? `aguardando há ${m} min` : `aguardando há ${Math.floor(m / 60)} h ${m % 60} min`;
};

export const beep = () => {
  try {
    const ac = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.18].forEach((t) => {
      const o = ac.createOscillator(); const g = ac.createGain();
      o.frequency.value = 880; o.connect(g); g.connect(ac.destination);
      g.gain.setValueAtTime(0.15, ac.currentTime + t); g.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + t + 0.15);
      o.start(ac.currentTime + t); o.stop(ac.currentTime + t + 0.16);
    });
  } catch { /* audio blocked until user interacts */ }
};

